class enabledIndicatorsServices {
    constructor($resource,SERVICE_URL_CONSTANT) {
		const services = $resource(SERVICE_URL_CONSTANT.adminPanel +'/enabled-indicator/:route',{},{
			getEnabledIndicators:{
				method:'GET',
				params : {}
			},
			saveEnabledIndicators:{
				method:'POST',
				params : {}
			},
		});

		const servicesPeriod = $resource(SERVICE_URL_CONSTANT.adminPanel +'/period/:route',{},{
			getPeriod:{
				method:'GET',
				params : {}
			},
		});

		return {
			services : services,
			servicesPeriod: servicesPeriod
		};
	}
}

enabledIndicatorsServices.$inject=['$resource','SERVICE_URL_CONSTANT']

export default  angular.module('services.enabledIndicatorsServices', [])
.service('enabledIndicatorsServices', enabledIndicatorsServices)
.name;



// WEBPACK FOOTER //
// ./src/app/admin-panel/enabledIndicators/enabledIndicatorsServices.js